import request from "../../../util/SuperagentUtils";
import { formatDateMMDDyyyy } from "../../../util/DateUtils";
import { supplierSpaceUsageReportEndpoints } from "../../api-endpoints";
import {MomentInput} from "moment";
import {getUrlSearchParamsByPaging} from "../../../util/UrlPagingParamUtils";

type SupplierSpaceUsageRequestParams = {
  page?: number;
  size?: number;
  startDate?: MomentInput;
  endDate?: MomentInput;
  locationId?: string;
  locationName?: string;
  bookingNumber?: string;
  overageInvoiceNumber?: string;
  sortBy?: string;
  sortDir?: string;
  groupBy?: string;
}

const getSpaceUsageQueryParams = (searchParams: SupplierSpaceUsageRequestParams, isPageable: boolean) => {

  const { page, size, startDate, endDate, locationId, locationName, bookingNumber, overageInvoiceNumber, sortBy, sortDir, groupBy } = searchParams;

  const queryParams = isPageable ? getUrlSearchParamsByPaging(page, size) : new URLSearchParams();

  if (startDate) queryParams.append("startDate", formatDateMMDDyyyy(startDate));
  if (endDate) queryParams.append("endDate", formatDateMMDDyyyy(endDate));
  if (locationId) queryParams.append("locationId", locationId);
  if (locationName) queryParams.append("locationName", locationName);
  if (bookingNumber) queryParams.append("bookingNumber", bookingNumber);
  if (overageInvoiceNumber) queryParams.append("overageInvoiceNumber", overageInvoiceNumber);
  if (sortBy) queryParams.append("sortBy", sortBy);
  if (sortDir) queryParams.append("sortDir", sortDir);
  if (groupBy) queryParams.append("groupBy", groupBy);

  return queryParams;
}

export const getSupplierSpaceUsageByPage = (searchParams: SupplierSpaceUsageRequestParams) => {

  return request.get(`${supplierSpaceUsageReportEndpoints.search}?${getSpaceUsageQueryParams(searchParams, true).toString()}`);
};

export const getSupplierSpaceUsageReportUrl = (searchParams: SupplierSpaceUsageRequestParams) => {
  return `${supplierSpaceUsageReportEndpoints.report}?${getSpaceUsageQueryParams(searchParams, false).toString()}`;
};

export const getSupplierSpaceUsageGroupSummaryReportUrl: (searchParams: SupplierSpaceUsageRequestParams) =>
  string = (searchParams) => {
    let summaryParams;

    if (searchParams) {
      summaryParams = {
        startDate: searchParams.startDate,
        endDate: searchParams.endDate,
        locationId: searchParams.locationId,
        locationName: searchParams.locationName,
        groupBy: searchParams.groupBy
      }
    }

  return summaryParams ? `${supplierSpaceUsageReportEndpoints.group}?${getSpaceUsageQueryParams(summaryParams, false)}` : "";
};
